export default "__VITE_ASSET__BT_QCU5F__"